import type { ReactNode } from 'react';
import { Animated, type ViewStyle } from 'react-native';
import { usePulseAnimation } from './useAnimations';

interface PulseAnimationProps {
  children: ReactNode;
  minOpacity?: number;
  maxOpacity?: number;
  duration?: number;
  style?: ViewStyle;
}

export function PulseAnimation({
  children,
  minOpacity = 0.4,
  maxOpacity = 1,
  duration = 1500,
  style,
}: Readonly<PulseAnimationProps>) {
  const { opacity } = usePulseAnimation({ minOpacity, maxOpacity, duration });

  return <Animated.View style={[{ opacity }, style]}>{children}</Animated.View>;
}
